import {
  GetEstadoProceso,
  PostCalcularAlcances,
  PostConfirmarAlcances,
  PostPrecalculo,
  PostCalcularComisiones,
  DeleteCalcularAlcances,
  DeleteConfirmarAlcances,
  DeletePrecalculo,
  DeleteCalcularComisiones,
  State as ComisionMembresiaState
} from "../../../reducers/comisionMembresia";

export interface ProcesoStore
  extends GetEstadoProceso,
    PostCalcularAlcances,
    PostConfirmarAlcances,
    PostPrecalculo,
    PostCalcularComisiones,
    DeleteCalcularAlcances,
    DeleteConfirmarAlcances,
    DeletePrecalculo,
    DeleteCalcularComisiones {}

export const procesoStore: (state) => ProcesoStore = state => {
  const comisionMembresia: ComisionMembresiaState = state.comisionMembresia;

  return {
    estadoProceso: comisionMembresia.estadoProceso,
    gettingEstadoProceso: comisionMembresia.gettingEstadoProceso,
    gettingEstadoProcesoError: comisionMembresia.gettingEstadoProcesoError,

    calcularAlcancesResult: comisionMembresia.calcularAlcancesResult,
    postingCalcularAlcances: comisionMembresia.postingCalcularAlcances,
    postingCalcularAlcancesError:
      comisionMembresia.postingCalcularAlcancesError,

    confirmarAlcancesResult: comisionMembresia.confirmarAlcancesResult,
    postingConfirmarAlcances: comisionMembresia.postingConfirmarAlcances,
    postingConfirmarAlcancesError:
      comisionMembresia.postingConfirmarAlcancesError,

    precalculoResult: comisionMembresia.precalculoResult,
    postingPrecalculo: comisionMembresia.postingPrecalculo,
    postingPrecalculoError: comisionMembresia.postingPrecalculoError,

    calcularComisionesResult: comisionMembresia.calcularComisionesResult,
    postingCalcularComisiones: comisionMembresia.postingCalcularComisiones,
    postingCalcularComisionesError:
      comisionMembresia.postingCalcularComisionesError,

    deleteCalcularAlcancesResult:
      comisionMembresia.deleteCalcularAlcancesResult,
    deletingCalcularAlcances: comisionMembresia.deletingCalcularAlcances,
    deletingCalcularAlcancesError:
      comisionMembresia.deletingCalcularAlcancesError,

    deleteConfirmarAlcancesResult:
      comisionMembresia.deleteConfirmarAlcancesResult,
    deletingConfirmarAlcances: comisionMembresia.deletingConfirmarAlcances,
    deletingConfirmarAlcancesError:
      comisionMembresia.deletingConfirmarAlcancesError,

    deletePrecalculoResult: comisionMembresia.deletePrecalculoResult,
    deletingPrecalculo: comisionMembresia.deletingPrecalculo,
    deletingPrecalculoError: comisionMembresia.deletingPrecalculoError,

    deleteCalcularComisionesResult:
      comisionMembresia.deleteCalcularComisionesResult,
    deletingCalcularComisiones: comisionMembresia.deletingCalcularComisiones,
    deletingCalcularComisionesError:
      comisionMembresia.deletingCalcularComisionesError
  };
};
